import { PushFaq } from '@components/push-faq/models';
import { Block } from '@shared/models';

export const pushFaqMock: Block<PushFaq> = {
  type: 'push-faq',
  data: {
    title: {
      text: `Que voulez-vous \\\\savoir sur [[cette cuisine]]`,
      as: 'span',
    },
    questions: [
      {
        label: `Comment se passe la pose de ma cuisine ? (1)`,
        url: '/mock-pose-cuisine-1',
      },
      {
        label: `Comment se passe la pose de ma cuisine ? (2)`,
        url: '/mock-pose-cuisine-2',
      },
      {
        label: `Comment se passe la pose de ma cuisine ? (3)`,
        url: '/mock-pose-cuisine-3',
      },
      {
        label: `Comment se passe la pose de ma cuisine ? (4)`,
        url: '/mock-pose-cuisine-4',
      },
    ],
    cta: {
      label: `Consulter la FAQ`,
      url: '/mock-faq',
    },
  },
};
